import { render } from "./CZAddClients.vue?vue&type=template&id=49137f88&scoped=true"
import script from "./CZAddClients.vue?vue&type=script&lang=js"
export * from "./CZAddClients.vue?vue&type=script&lang=js"

import "./CZAddClients.vue?vue&type=style&index=0&id=49137f88&scoped=true&lang=css"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49137f88"]])

export default __exports__